//
// README - Beta Component
//
// This component is marked "beta" and will go through some iterations
// before landing at a final solution. Please reach out to the Cadence team
// if you intend to use this in the meantime and we'll help you out!
//

import React from 'react';
import { RCFavoriteCard } from '../internalComponents';
import type { LinkElementProps } from '../internalComponents/RCFavoriteCard/RCFavoriteCard';
import { RCStarRating, RCAvatar } from '../';
import DefaultShopAvatar from '../../images/avatars/shop-brand-default.png';

export interface Shop {
  name: string;
  location: string;
  rating: number;
  ratingCount?: number;
  thumbnailURL?: string;
}

interface RCSavedShopCardProps {
  shop: Shop;
  secondaryAction?: React.ReactElement;
  watchButtonElement?: React.ReactElement;
  linkElement: (children: React.ReactNode) => React.ReactElement<LinkElementProps>;
  verticalStretch?: boolean;
  clickableCard?: boolean;
}

export function RCSavedShopCard({
  shop,
  secondaryAction = undefined,
  watchButtonElement = undefined,
  verticalStretch = false,
  linkElement,
  clickableCard = true,
}: RCSavedShopCardProps) {
  return (
    <RCFavoriteCard
      type="shop"
      title={shop.name}
      subtitle={shop.location}
      primaryAction={watchButtonElement}
      secondaryAction={secondaryAction}
      linkElement={linkElement}
      verticalStretch={verticalStretch}
      clickableCard={clickableCard}
      additionalContent={
        <RCStarRating
          rating={shop.rating}
          count={shop.ratingCount}
          hideTooltip
        />
      }
      avatar={
        <RCAvatar
          userName={shop.name}
          thumbnailURL={shop.thumbnailURL || DefaultShopAvatar}
          useInitialFallback
        />
      }
    />
  );
}
